import styled from "styled-components";
import { Avatar } from "@mui/material";

export const AvaterController = styled(Avatar)`
  && {
    width: ${(props) => props.width};
    height: ${(props) => props.height};
    background: ${(props) => props.bg};
    font-size: ${(props) => props.fz};
  }
`;
